import { render } from "./BnTableHeaderCell.vue?vue&type=template&id=48323943&scoped=true"
import script from "./BnTableHeaderCell.vue?vue&type=script&lang=js"
export * from "./BnTableHeaderCell.vue?vue&type=script&lang=js"

import "./BnTableHeaderCell.vue?vue&type=style&index=0&id=48323943&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48323943"]])

export default __exports__